import { z } from "zod";
const zodValidator = (options) => {
  const input = "input" in options ? options.input : "input";
  const output = "output" in options ? options.output : "output";
  const _input = "schema" in options ? options.schema._input : options._input;
  const _output = "schema" in options ? options.schema._output : options._output;
  return {
    types: {
      input: input === "output" ? _output : _input,
      output: output === "input" ? _input : _output
    },
    parse: (input2) => "schema" in options ? options.schema.parse(input2) : options.parse(input2)
  };
};
const fallback = (schema, fallback2) => {
  return z.custom().pipe(schema.catch(fallback2));
};
export {
  fallback,
  zodValidator
};
//# sourceMappingURL=index.js.map
